import React from 'react';

function Footer() {
  return (
    <footer id="main-footer">
      <p>Hotel Atlanta &copy; 1953, All Rights Reserved</p>
    </footer>
  );
}

export default Footer;